export const ON_INIT_ERROR = 'onInitError' as const;
export const SUBSCRIBE_TO_CHANGES_ERROR = 'subscribeToChangesError' as const;
export const GET_API_ERROR = 'getApiError' as const;

export const BRIDGE_ERROR_TYPES: readonly [
	'onInitError',
	'subscribeToChangesError',
	'getApiError',
] = [ON_INIT_ERROR, SUBSCRIBE_TO_CHANGES_ERROR, GET_API_ERROR] as const;
